var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternalLinkPurple = function SvgExternalLinkPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 4.167H4.999A.833.833 0 0 0 4.166 5v10c0 .46.373.834.833.834h10c.46 0 .834-.373.834-.834v-3.333",
    stroke: "url(#external_link_purple_svg__a)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 7.5a.75.75 0 0 0 1.5 0h-1.5Zm.75-4.167h.75a.75.75 0 0 0-.75-.75v.75Zm-4.167-.75a.75.75 0 0 0 0 1.5v-1.5ZM17.417 7.5V3.333h-1.5V7.5h1.5Zm-.75-4.917H12.5v1.5h4.167v-1.5Z",
    fill: "url(#external_link_purple_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.304 8.636a.75.75 0 0 0 1.06 1.06l-1.06-1.06Zm6.894-4.773a.75.75 0 0 0-1.061-1.06l1.06 1.06Zm-5.834 5.834 5.834-5.834-1.061-1.06-5.833 5.833 1.06 1.06Z",
    fill: "url(#external_link_purple_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "external_link_purple_svg__a",
    x1: 4.354,
    y1: 5.108,
    x2: 15.49,
    y2: 12.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF2D83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "external_link_purple_svg__b",
    x1: 12.567,
    y1: 3.669,
    x2: 16.544,
    y2: 6.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF2D83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "external_link_purple_svg__c",
    x1: 10.928,
    y1: 3.803,
    x2: 16.496,
    y2: 7.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF2D83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF"
  })))));
};

export { SvgExternalLinkPurple as ReactComponent };
export default "data:image/svg+xml;base64,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";